export const TEST_ID = 'sideRail';
